import { render, staticRenderFns } from "./CapacitacionGracias.vue?vue&type=template&id=8271b658&scoped=true"
import script from "./CapacitacionGracias.vue?vue&type=script&lang=js"
export * from "./CapacitacionGracias.vue?vue&type=script&lang=js"
import style0 from "./CapacitacionGracias.vue?vue&type=style&index=0&id=8271b658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8271b658",
  null
  
)

export default component.exports